/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FolderIcon16Light } from './FolderIcon16Light';
import { FolderIcon16Regular } from './FolderIcon16Regular';
import { FolderIcon16Solid } from './FolderIcon16Solid';
import { FolderIcon20Light } from './FolderIcon20Light';
import { FolderIcon20Regular } from './FolderIcon20Regular';
import { FolderIcon20Solid } from './FolderIcon20Solid';
import { FolderIcon24Regular } from './FolderIcon24Regular';
import { FolderIcon24Solid } from './FolderIcon24Solid';
import { FolderIcon32Regular } from './FolderIcon32Regular';
import { FolderIcon64Regular } from './FolderIcon64Regular';
var sizes = {
    16: {
        light: FolderIcon16Light,
        regular: FolderIcon16Regular,
        solid: FolderIcon16Solid,
    },
    20: {
        light: FolderIcon20Light,
        regular: FolderIcon20Regular,
        solid: FolderIcon20Solid,
    },
    24: {
        regular: FolderIcon24Regular,
        solid: FolderIcon24Solid,
    },
    32: {
        regular: FolderIcon32Regular,
    },
    64: {
        regular: FolderIcon64Regular,
    },
};
export var FolderIcon = forwardRef('FolderIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
